export default "__VITE_ASSET__DUPH8L17__"